<template>
  <div>
    <div class="connect-domain cursor-pointer">
      <div class="first__step">
        <div class="btn__connect__domain" @click="showModal = true">{{ t.connect_funnel_domain }}</div>
      </div>
    </div>

    <div class="connect-domain--modal" v-if="showModal" @click="setToggleModal ? toogleModal() : ''">
      <div class="box-options" @mouseleave="setToggleModal = true" @mouseover="setToggleModal = false">
        <div class="close-modal">
          <svg class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="toogleModal">
            <g clip-path="url(#clip0_468_3857)">
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#F92A38"/>
            </g>
            <defs>
              <clipPath id="clip0_468_3857">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="box-options--header">
          <span>{{ t.want_connect_domain }}</span>
        </div>
        <div class="box-options--content">
          <div class="cd-card" v-for="(cn, i) in connections" :key="i">
            <img :src="`/internacional/public/office6/img/connect-domain/${cn.icon}`">
            <span class="title">{{ t[cn.title] }}</span>
            <span class="subtitle">{{ decodeString(t[cn.description]) }}</span>
            <div class="action cursor-pointer" @click="run(cn.link)">{{ t[cn.button] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'connect-domain',
  props: {
    view: {
      type: Object
    }
  },
  data() {
    return {
      t: null,
      showModal: false,
      setToggleModal: false,
      connections: [
        { icon: 'builderall-builder.svg', title: 'cd_bb_title', description: 'cd_bb_description', button: 'website_builder', link: 'https://office.builderall.com/us/office/cheetah-builder' },
        { icon: 'mailingboss.svg', title: 'cd_mailingboss_title', description: 'cd_mailingboss_description', button: 'checkout_title_plan_mb_starter_toolannual_brl', link: 'https://app.mailingboss.com/customer' },
        { icon: 'wordpress.svg', title: 'cd_wordpress_title', description: 'cd_wordpress_description', button: 'checkout_title_plan_wordpress_starter_toolannual_brl', link: 'https://wordpress.builderall.com/sites' },
        { icon: 'afiiliate.svg', title: 'cd_afiiliate_title', description: 'cd_afiiliate_description', button: 'affiliates_funnel', link: 'https://office.builderall.com/us/office/franchise-system' },
      ]
    }
  },
  created() {
    this.t = this.view.translation
  },
  methods: {
    toogleModal() {
      this.showModal = false
    },
    decodeString(string) {
      return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent;
    },
    run(to) {
      window.open(to, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.connect-domain {
  width: 140px;
  height: 40px;
  max-width: 140px;

  background: #FFFFFF;
  border-radius: 4px;

  .first__step {
    height: 100%;
    display: flex;

    .btn__connect__domain {
      border-radius: 6px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0072E1;
      color: #fff;

      font-size: 13px;
      font-weight: 900;
      text-align: center;
      padding: 4px;
      text-transform: uppercase;
    }
  }
}
.connect-domain--modal {
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -80%);
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  margin: 0;
  background: rgba(0,0,0,0.5);
  .box-options {
    width: 974px;
    height: 495px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 1px 2px 15px 0px rgba(0, 0, 0, 0.11);
    padding: 27px;
    .close-modal {
      display: flex;
      justify-content: flex-end;
    }
    .box-options--header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 25px;
      margin-bottom: 25px;
      span {
        color: #2A3C51;
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: Mulish;
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      &::after {
        position: absolute;
        bottom: 0;
        content: "";
        width: 865px;
        height: 1px;
        background: rgba(77, 93, 113, 0.25);
      }
    }
    .box-options--content {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: stretch;
      .cd-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 180px;
        height: 314px;
        img {
          width: 30px;
          height: 30px;
          margin-bottom: 7px;
        }
        .title {
          height: 76px;
          color: #2A3C51;
          text-align: center;
          font-family: Montserrat;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          letter-spacing: 0.88px;
        }
        .subtitle {
          height: 138px;
          color: #7191B4;
          text-align: center;
          leading-trim: both;
          text-edge: cap;
          font-feature-settings: 'clig' off, 'liga' off;
          font-family: Montserrat;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 23px;
          margin-bottom: 14px;
        }
        .action {
          display: flex;
          width: 179px;
          height: 40px;
          padding: 10px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 6px;
          background: #0072E1;
          text-transform: uppercase;

          color: #FFF;
          text-align: center;
          font-family: Montserrat;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.66px;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/connect-domain/index.vue